import mixin from '../../../../mixins/mixin';
import vrboLodgingConfigEnumerations from './VrboLodgingConfigEnumerations';
import vrboService from '../../../../services/vrbo';

export default {
  name: 'VrboDefaultConfigurationTab',

  props: ['user', 'userId'],

  data() {
    return {
      loading: false,
      vrboBookingPolicies: vrboLodgingConfigEnumerations.vrboBookingPolicies,
      vrboCancellationPolicies: vrboLodgingConfigEnumerations.vrboCancellationPolicies,
      vrboBookingSelectedPolicy: 'INSTANT',
      vrboCancellationSelectedPolicy: 'NO_REFUND',
      vrboCheckTimes: vrboLodgingConfigEnumerations.vrboCheckTimes,
      vrboDefaultCheckin: '15:00',
      vrboDefaultCheckout: '10:00',
      vrboDefaultChildrenEnabled: true,
      vrboDefaultEventsEnabled: true,
      vrboDefaultPetsEnabled: true,
      vrboDefaultSmokingDisabled: true,
      maximumOccupancyAdults: 5,
      maximumOccupancyGuests: 5,
      merchantName: '',
      minimumAgeRule: 18,
    };
  },

  mixins: [mixin],

  components: {
    Redactor: require('components/redactor/redactor.vue'),
    VLoading: require('components/loading/loading.vue'),
  },

  mounted() {
  },

  watch: {
    user(newUser) {
      if (newUser && newUser.vrbo_account) {
        this.vrboBookingSelectedPolicy = newUser.vrbo_account.booking_policy;
        this.vrboCancellationSelectedPolicy = newUser.vrbo_account.cancellation_policy;
        this.vrboDefaultCheckin = newUser.vrbo_account.checkin_time;
        this.vrboDefaultCheckout = newUser.vrbo_account.checkout_time;
        this.vrboDefaultChildrenEnabled = newUser.vrbo_account.children_enabled;
        this.vrboDefaultEventsEnabled = newUser.vrbo_account.events_enabled;
        this.vrboDefaultPetsEnabled = newUser.vrbo_account.pets_enabled;
        this.vrboDefaultSmokingDisabled = !newUser.vrbo_account.smocking_enabled;
        this.maximumOccupancyAdults = newUser.vrbo_account.maximum_occupancy_adults;
        this.maximumOccupancyGuests = newUser.vrbo_account.maximum_occupancy_guests;
        this.merchantName = newUser.vrbo_account.merchant_name;
        this.minimumAgeRule = newUser.vrbo_account.minimum_age_rule;
      }
    },
  },

  methods: {
    enableChildren() {
      this.vrboDefaultChildrenEnabled = !this.vrboDefaultChildrenEnabled;
    },

    enableEvents() {
      this.vrboDefaultEventsEnabled = !this.vrboDefaultEventsEnabled;
    },

    enablePets() {
      this.vrboDefaultPetsEnabled = !this.vrboDefaultPetsEnabled;
    },

    enableSmoking() {
      this.vrboDefaultSmokingDisabled = !this.vrboDefaultSmokingDisabled;
    },

    saveData() {
      const data = {
        user_id: this.userId,
        booking_policy: this.vrboBookingSelectedPolicy,
        cancellation_policy: this.vrboCancellationSelectedPolicy,
        checkin_time: this.vrboDefaultCheckin,
        checkout_time: this.vrboDefaultCheckout,
        children_enabled: this.vrboDefaultChildrenEnabled,
        events_enabled: this.vrboDefaultEventsEnabled,
        pets_enabled: this.vrboDefaultPetsEnabled,
        smocking_enabled: !this.vrboDefaultSmokingDisabled,
        maximum_occupancy_adults: this.maximumOccupancyAdults,
        maximum_occupancy_guests: this.maximumOccupancyGuests,
        merchant_name: this.merchantName,
        minimum_age_rule: this.minimumAgeRule,
      };

      vrboService.vrboUpdateDefaultLodgingConfig(this, data, this.userId);
    },
  },

  computed: {
    account() {
      return this.$store.state.account;
    },
  },
};




// WEBPACK FOOTER //
// ./src/app/pages/account/settings/VrboDefaultConfigurationTab/VrboDefaultConfigurationTab.js